import { hooks } from "./Runtime.js";
import { registerAppI18n } from "./registerAppI18n.js";
export async function fulfilStoryboard(storyboard) {
  if (storyboard.$$fulfilled) {
    return;
  }
  if (!storyboard.$$fulfilling) {
    storyboard.$$fulfilling = doFulfilStoryboard(storyboard);
  }
  return storyboard.$$fulfilling;
}
async function doFulfilStoryboard(storyboard) {
  var _hooks$fulfilStoryboa;
  await (hooks === null || hooks === void 0 || (_hooks$fulfilStoryboa = hooks.fulfilStoryboard) === null || _hooks$fulfilStoryboa === void 0 ? void 0 : _hooks$fulfilStoryboa.call(hooks, storyboard));
  registerAppI18n(storyboard);
  Object.assign(storyboard, {
    $$fulfilled: true,
    $$fulfilling: null
  });
}
//# sourceMappingURL=fulfilStoryboard.js.map